import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  activeButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '28px',
    backgroundColor: '#FFFFFF',
    borderRadius: '5px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '13px',
    color: '#3C419A',
    cursor: 'pointer',
    marginRight: '10px',
    marginBottom: '10px',
    boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 1px 10px rgba(0, 0, 0, 0.12)',
  },

  disableButton: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '28px',
    backgroundColor: '#6F707B',
    borderRadius: '5px',
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '13px',
    color: '#FFFFFF',
    marginRight: '10px',
    marginBottom: '10px',
    cursor: 'not-allowed',
    pointerEvents: 'all',
    '& .MuiButton-label': {
      justifyContent: 'space-between',
    },
  },
}));
